import { Button, Col, Input, Row, Skeleton, Table, Form } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { SearchOutlined,  } from '@ant-design/icons';
import { map, get } from "lodash";

import api from '../../../services/systemConfigService';
import { recordError } from '../../../utils/logService';
import AddressDetails from './AddressDetails';

import {
  Messages,
  Notify,
  openNotification,
  util
} from '@seims/shared';

const AddressList = () => {
    const title = "Address Correction";
    const subTitle = "Search for addresses";
    const {key} = useParams();
    const navigate = useNavigate();

    const [addresses, setAddresses] = useState([])
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [visible, setVisible] = useState(false);

    const [selectedAddress, setSelectedAddress] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [firstRecord, setFirstRecord] = useState(0);
    const [isNotSearchable, setIsNotSearchable] = useState(true);
    const [isSearchedResults, setIsSearchedResults] = useState(false);
    const [currentTab, setCurrentTab] = useState("invalidAddresses");

    const [form] = Form.useForm();

    const tabList = [
        {
          key: "invalidAddresses",
          label: "Invalid Addresses",
        },
        {
          key: "validAddresses",
          label: "Valid Addresses",
        }
      ];
    
    const columns = [
    {
        title: "Street Address",
        dataIndex: "street",
        key: "street4",
        sorter: (a, b) => a.street.localeCompare(b.street),
    },
    {
        title: "Country",
        dataIndex: "country",
        key: "country",
        sorter: (a, b) => a.country.localeCompare(b.country),
    },
    {
        title: "District",
        dataIndex: "district",
        key: "district3",
        sorter: (a, b) => a.district.localeCompare(b.district),
    },
    {
        title: "City/Town",
        dataIndex: "cityOrTown",
        key: "cityOrTown4",
        sorter: (a, b) => a.cityOrTown.localeCompare(b.cityOrTown),
    },
    {
        title: "Postal Code",
        dataIndex: "postalCode",
        key: "postalCode4",
    },
    {
        title: "Latitude",
        dataIndex: "x",
        key: "x",
        sorter: (a, b) => a.cityOrTown.localeCompare(b.cityOrTown),
    },
    {
        title: "Longitude",
        dataIndex: "y",
        key: "y",
    },
    {
        title: "Actions",
        dataIndex: "actions",
        key: "View-5",
        render: (_, record) => {
        return (
            <>
            <a key={"a-" + record.id} onClick={() => showModal(record)}>
                Update{" "}
            </a>
            </>
        );
        },
    },
    ];

    useEffect(() => {
        getInvalidAddresses({ type: currentTab });
      }, [visible == false]);

    useEffect(() => {
        if (key > 0) getAddress(key);        
    }, [])
    
    const getAddress = async (key) => {
        try {
            const response = await api.getInvalidAddress(key);

        if (response && response.status === 200) {
          const { data } = response;

          if (data.invalid) {
              setSelectedAddress(data);
              showModal(data);
          }
        }
      } catch (error) {
        recordError(error);
        if (error?.response?.status == 403) {
            msg = util.parseMessage(error?.response?.data.message, "Address");
            openNotification("Address Correction", msg, Notify.WARNING);
            navigate("/system/addresscorrection");

            return;
        }

        msg = util.parseMessage(Messages.GET_FAILURE, "Address Correction");
        openNotification("System failed to load invalid address", msg, Notify.ERROR);
      }
    };


    
    let msg = "";

    const getInvalidAddresses = async ({
            type = currentTab,
            first = firstRecord,
            max = pageSize,
            searchValue = searchText,
            clearSearch = true
        }) => {
        if (clearSearch) {
            setSearchText("");
            searchValue = null;
        }
        setTotal(0);
        const entity = "Address List";
        try {
            setLoading(true);
            const response = await api.getInvalidAddresses()

            if (response && response.status === 200) {
                const { data } = response;
                setTotal(data?.total);
                
                setAddresses(data);
                setFilteredData(data);
                setLoading(false);
            }
            else if (response && response.status === 204) {
                setLoading(false);
                setAddresses([]);
                setFilteredData([]);
            }
            else {
                setAddresses([]);
                setFilteredData([]);
            }
        } catch (error) {
            msg = util.parseMessage(Messages.GET_FAILURE, entity);
            openNotification("System failed to load invalid addresses", msg, Notify.ERROR);
            recordError(error);
        }
        setIsSearchedResults(searchValue !== null && searchValue !== undefined && searchValue !== "");
    }

    const globalSearch = (searchValue) => {

        if (searchValue === "") {
            getInvalidAddresses({ type: currentTab });
            // setFilteredData(filteredData);
            return;
        }

        const reg = new RegExp(searchValue.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&"), "gi");

        var _filteredData = map(filteredData, (record) => {
            const street = get(record, "street").match(reg);
            const district = get(record, "district").match(reg);
            const province = get(record, "province").match(reg);
            const cityOrTown = get(record, "cityOrTown").match(reg);

            if (!street && !district && !province && !cityOrTown) {
                return null;
            }
            return record;
        }).filter((record) => record);

        setFilteredData(_filteredData);
    };
    const handleInputChange = (e) => {
        const { value: searchValue } = e.target;
        setSearchText(searchValue);
        globalSearch(searchValue);
        
    };
    const onRowChange = (row) => {
        setPageSize(row.pageSize);
    };

    const onPageChange = (page, size) => {
        const keepCurrentPage = pageSize === size;
        const first = keepCurrentPage ? (page - 1) * pageSize : 0;
        const newPage = keepCurrentPage ? page : 1;
        setFirstRecord(first);
        setPageSize(size);
        setCurrentPage(newPage);
        getInvalidAddresses();
    }

    const handleSearchRequest = async () => {
        // Do nothing if searchText is empty on hitting enter
        if (searchText.length > 0) {
            setFirstRecord(0);
            getInvalidAddresses({ type: currentTab });
            setIsSearchedResults(true);
        }
    };

    const onTabChange = (type) => {

        setFirstRecord(0);
        setCurrentPage(1);
        setSearchText("");
        setCurrentTab(type);
        getInvalidAddresses({ type: type });
    };
    const handleSubmit = async (values)=>{
        // call API to update address
        try {
            const {id} = values;
            const response = await api.updateAddress(id, values);

            if (response && response.status === 200) {
                const {data} = response;
                msg = util.parseMessage(Messages.UPDATE_SUCCESS, "Address");
                openNotification("Address Correction", msg, Notify.SUCCESS);
                setVisible(false);
                if (key > 0){
                    navigate("/system/addresscorrection");
                }
            }
            
        } catch (error) {
            
            recordError(error);
            if (error?.response?.status == 400) {
                msg = error?.response?.data.message;
                const {details = [], message} = error?.response?.data;

                // const municipalityErr = d.some((v) => v.includes("municipal"));
                
                const fields = details.map((value) => {

                    if (value.includes("district")) {
                        return {
                            name: 'district',
                            errors: [value], 
                        }
                    }

                    if (value.includes("province")) {
                        return {
                            name: 'province',
                            errors: [value], 
                        }
                    }

                    if (value.includes("country")) {
                        return {
                            name: 'country',
                            errors: [value], 
                        }
                    }
                }).filter((v) => v != null);

                form.setFields(fields);
                
                openNotification("Address Correction", message, Notify.WARNING);
                return false;
            }

            if (error?.response?.status == 403) {
                msg = util.parseMessage(error?.response?.data.message, "Address");
                openNotification("Address Correction", msg, Notify.WARNING);
                return false;
            }
            
            msg = util.parseMessage(Messages.UPDATE_FAILURE, "Address");
            openNotification("Address Correction", msg, Notify.ERROR);
            setVisible(true);

        }
        return true;
    }

    const handleCancel =()=>{
        setVisible(false);
        
    }

    const showModal = (record) => {
        setVisible(true);
        setSelectedAddress(record)
        
      };

    return (
        <div className='content'>
            <h1 className="center-align">{title}</h1>
            <div>{subTitle}</div>
            <Row>
                <Col xs={24} md={8}>

                    <Input
                        placeholder="Search Invalid Addresses"
                        type="text"
                        onChange={handleInputChange}
                        onPressEnter={handleInputChange}
                        onPaste={handleInputChange}
                        // value={searchText}
                        allowClear
                        size="large"
                        prefix={<SearchOutlined />}
                    />
                </Col>
                <Col className="">
                    <Button
                        disabled={isNotSearchable}
                        key="Search"
                        value="Search"
                        type="primary"
                        onClick={handleSearchRequest}
                        style={{ marginLeft: 10 }}
                    >
                        Search
                    </Button>
                </Col>
            </Row>
            <div className="space"></div>
            {/* <Tabs
                className=""
                type="card"
                onChange={onTabChange}
                items={tabList}
                key="repo-table-1" /> */}
            {loading ?
                <Skeleton active avatar />
                :
                <Table
                    dataSource={filteredData}
                    columns={columns}
                    loading={loading}
                    rowKey={(record) => record.id}
                    bordered
                    pagination={{
                        defaultCurrent: 1,
                        current: currentPage,
                        defaultPageSize: pageSize,
                        total: total,
                        pageSize: pageSize,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        onChange: onPageChange,
                        pageSizeOptions: [2, 5, 10, 20, 50, 100],
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} ${total>1 ? 'Addresses' : 'Address'}`,
                      }}
                    size="middle"
                />}

                <AddressDetails onCancel={handleCancel} visible={visible} onModalSubmit={handleSubmit} selectedAddress={selectedAddress} form={form} />
        </div>
    );
}

export default AddressList